import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-checkbox-wrapper",
    class: this.helpers.getClasses()
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-checkbox-icon.item-icon",
    style: this.helpers.getIconStyles()
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-checkbox-animation-layer"
  }), /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: this.helpers.getIconAttributes()
  })), this.attr(`icon`) ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-checkbox-additional-icon"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: this.attr(`icon`) }
  })) : null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-checkbox-label"
  }, /* @__PURE__ */ jsx("slot", null)));
}
